import { useEffect } from 'react';

function useRegisterFingerPay() {
    useEffect(() => {
        // @ts-ignore
        window.pay_result_submit = () => {
            // @ts-ignore
            payResultSubmit();
        };
        // @ts-ignore
        window.pay_result_close = () => {
            console.log('결제창 닫기');
        };

        return () => {
            // @ts-ignore
            window.pay_result_submit = undefined;
            // @ts-ignore
            window.pay_result_close = undefined;
        };
    }, []);
}

export default useRegisterFingerPay;
